/** Error message prefix used when a path string cannot be parsed. */
export const invalidPathValue = "Invalid path value";
